import { Column } from '@mode/shared/contract-common';
export function generatePreviewTableQuery({
  tableSchema,
  tableName,
  tableColumns,
}: {
  tableSchema: string;
  tableName: string;
  tableColumns?: Column[];
}): string {
  let columnString = '\n';
  if (tableColumns && tableColumns.length > 0) {
    tableColumns.forEach((col, index) => {
      if (index === tableColumns.length - 1) {
        columnString += `\t\t${col.name}\n`;
      } else {
        columnString += `\t\t${col.name},\n`;
      }
    });
  } else {
    columnString = '*';
  }
  return `-- Returns first 100 rows from ${tableSchema}.${tableName}
  SELECT ${columnString} FROM ${tableSchema}.${tableName} LIMIT 100;`;
}
